"use client";

import * as Accordion from "@radix-ui/react-accordion";

import {
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "@/components/ui/accordion";

import { useState } from "react";
import { FAQData } from "@/fixtures/FAQ";
import { Minus, Plus } from "lucide-react";

const AccordionFAQ = () => {
	const [expandedItems, setExpandedItems] = useState<string[]>([]);

	const handleToggleItem = (itemValue: string) => {
		setExpandedItems((prevItems) =>
			prevItems.includes(itemValue)
				? prevItems.filter((item) => item !== itemValue)
				: [...prevItems, itemValue]
		);
	};

	const isItemExpanded = (itemValue: string) =>
		expandedItems.includes(itemValue);
	return (
		<div className='flex flex-col items-center justify-center gap-8'>
			<h2 className='text-center text-3xl font-bold text-blue-500 '>
				Frequently asked questions
			</h2>
			<Accordion.Root
				type='single'
				collapsible
				className='w-11/12 max-w-[24rem] md:max-w-[52rem] mt-6 h-full'
			>
				<div className='w-full border-t-[2px] border-slate-700'></div>
				{FAQData.map((item: Record<string, any>, index: number) => (
					<AccordionItem
						key={`item-${index + 1}`}
						value={`item-${index + 1}`}
						className='border-t-[1.75px] last:border-b-[2.5px] border-slate-700'
					>
						<div className='flex flex-row gap-5'>
							<Accordion.Trigger className='text-iconLightBlue'>
								{isItemExpanded(`item-${index + 1}`) ? (
									<Minus width={24} height={24} aria-hidden />
								) : (
									<Plus width={24} height={24} aria-hidden />
								)}
							</Accordion.Trigger>
							<AccordionTrigger
								onClick={() => handleToggleItem(`item-${index + 1}`)}
								className='font-latoFont text-[1.25rem] text-start focus:no-underline'
							>
								{item.title}
							</AccordionTrigger>
						</div>
						<AccordionContent className='font-normal font-white font-latoFont text-lg opacity-75 pl-[2.75rem] leading-6'>
							{item.description}
						</AccordionContent>
					</AccordionItem>
				))}
			</Accordion.Root>
		</div>
	);
};

export default AccordionFAQ;
